module.exports = __webpack_public_path__ + "assets/b3d878e2441590873ca5e097f8abc9ea.svg";